export default ($http) => ({
  getSupportTeam() {
    return $http.get('support-team')
  },
  disableArchivingAlert() {
    return $http.post('hide-archive-alert')
  }
})
